import { createTheme } from "@mui/material/styles";

// === Light Theme (Static - No Changes) ===
// export const lightTheme = createTheme({
//   palette: {
//     mode: "light",
//     primary: {
//       main: "#464342",
//     },
//     background: {
//       default: "#f5f5f5",
//       paper: "rgb(222, 222, 222)",
//     },
//     text: {
//       primary: "#000000",
//       secondary: "#455a64",
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#ffffff",
//           color: "#000000",
//         },
//       },
//     },
//     MuiTableHead: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#e0e0e0",
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         head: {
//           color: "#000000",
//           fontWeight: "bold",
//         },
//       },
//     },
//     MuiToggleButtonGroup: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#e0e0e0",
//           borderRadius: 8,
//           padding: 4,
//           width: "fit-content",
//         },
//       },
//     },
//     MuiCssBaseline: {
//       styleOverrides: {
//         body: {
//           "&::-webkit-scrollbar": {
//             width: "8px",
//             height: "8px",
//           },
//           "&::-webkit-scrollbar-track": {
//             background: "#1e1e1e",
//           },
//           "&::-webkit-scrollbar-thumb": {
//             backgroundColor: "#888",
//             borderRadius: "10px",
//             border: "2px solid transparent",
//             backgroundClip: "content-box",
//           },
//           "&::-webkit-scrollbar-thumb:hover": {
//             backgroundColor: "#555",
//           },
//         },
//       },
//     },
//     MuiToggleButton: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           fontWeight: "bold",
//           paddingLeft: theme.spacing(4),
//           paddingRight: theme.spacing(4),
//           borderRadius: 8,
//           "&.Mui-selected": {
//             color: "#fff",
//             backgroundColor: (ownerState) =>
//               ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
//             "&:hover": {
//               backgroundColor: (ownerState) =>
//                 ownerState.value === "BUY" ? "#00a543" : "#b71c1c",
//             },
//           },
//           "&:not(.Mui-selected)": {
//             color: (ownerState) =>
//               ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
//             "&:hover": {
//               backgroundColor: "#e0e0e0",
//             },
//           },
//         }),
//       },
//     },
//     MuiDialogTitle: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#e4e0e0",
//           color: "#000",
//           fontWeight: "bold",
//         },
//       },
//     },
//   },
// });

// === Dynamic Dark Theme (Uses API Colors) ===
export const createDarkTheme = (allColors) => {
  // Fallback to default dark theme colors if API values are null
  const defaults = {
    navbarColor: "#000",
    darkBackgroundColor: "#000",
    backgroundColor1: "#121212",
    backgroundColor2: "#1e1e1e",
    buttonColor: "#90caf9",
    fontColor: "#ffffff",
    popupHeaderColor: "#383839",
    popupBodyColor: "#1e1e1e",
    tableHeaderColor: "#202023",
    tableBodyColor: "#24262d",
  };

  // Merge API colors with defaults
  const colors = {
    navbarColor: allColors?.navbarColor || defaults.navbarColor,
    darkBackgroundColor:
      allColors?.darkBackgroundColor || defaults.darkBackgroundColor,
    backgroundColor1: allColors?.backgroundColor1 || defaults.backgroundColor1,
    backgroundColor2: allColors?.backgroundColor2 || defaults.backgroundColor2,
    buttonColor: allColors?.internalButtonColor || defaults.buttonColor,
    fontColor: allColors?.fontColor || defaults.fontColor,
    popupHeaderColor: allColors?.popupHeaderColor || defaults.popupHeaderColor,
    popupBodyColor: allColors?.popupBodyColor || defaults.popupBodyColor,
    tableHeaderColor: allColors?.tableHeaderColor || defaults.tableHeaderColor,
    tableBodyColor: allColors?.tableBodyColor || defaults.tableBodyColor,
  };

  return createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: colors.buttonColor,
      },
      background: {
        default: colors.darkBackgroundColor,
        paper: "#1e1e1e",
      },
      text: {
        primary: colors.fontColor,
        secondary: colors.fontColor,
      },
    },
    typography: {
      fontFamily: colors.font,
      fontSize: colors.fontSize,
      fontStyle: colors.fontStyle,
      allVariants: {
        color: colors.fontColor,
        fontStyle: colors.fontStyle,
      },
      h1: {
        fontSize: `${allColors.fontSize * 2.4}px`,

        color: allColors.fontColor,
      },
      h2: {
        fontSize: `${allColors.fontSize * 2}px`,

        color: allColors.fontColor,
      },
      h3: {
        fontSize: `${allColors.fontSize * 1.8}px`,

        color: allColors.fontColor,
      },
      h4: {
        fontSize: `${allColors.fontSize * 1.5}px`,

        color: allColors.fontColor,
      },
      h5: {
        fontSize: `${allColors.fontSize * 1.3}px`,

        color: allColors.fontColor,
      },
      h6: {
        fontSize: `${allColors.fontSize * 1.1}px`,

        color: allColors.fontColor,
      },
      subtitle1: {
        fontSize: `${allColors.fontSize * 1}px`,
        color: allColors.fontColor,
      },
      subtitle2: {
        fontSize: `${allColors.fontSize * 0.9}px`,
        color: allColors.fontColor,
      },
      body1: {
        fontSize: `${allColors.fontSize}px`,
        color: allColors.fontColor,
      },
      body2: {
        fontSize: `${allColors.fontSize * 0.9}px`,
        color: allColors.fontColor,
      },
      button: {
        textTransform: "none",

        fontSize: `${allColors.fontSize}px`,
        color: allColors.fontColor,
      },
      caption: {
        fontSize: `${allColors.fontSize * 0.8}px`,
        color: allColors.fontColor,
      },
      overline: {
        fontSize: `${allColors.fontSize * 0.75}px`,
        color: allColors.fontColor,
        textTransform: "uppercase",
      },
    },
    components: {
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: colors.popupBodyColor,
            backgroundImage: "none", // Remove any gradient
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: colors.darkBackgroundColor,
            color: colors.fontColor,
            fontStyle: allColors?.fontStyle,
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: colors.tableHeaderColor,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            // color: colors.fontColor,
            fontWeight: "bold",
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            backgroundColor: `color-mix(in srgb, ${colors.darkBackgroundColor} 80%, white 20%)`,
            color: colors.fontColor,
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            backgroundColor: "transparent", // Changed to transparent
            paddingTop: 0, // Remove gap between title and content
            borderTop: "none", // Remove any border
            borderBottom: "none", // Remove any border
            // "&::-webkit-scrollbar": {
            //   width: "8px",
            //   height: "8px",
            // },
            // "&::-webkit-scrollbar-track": {
            //   background: colors.darkBackgroundColor,
            // },
            // "&::-webkit-scrollbar-thumb": {
            //   backgroundColor: colors.darkBackgroundColor,
            //   borderRadius: "10px",
            //   border: "2px solid transparent",
            //   backgroundClip: "content-box",
            // },
            // "&::-webkit-scrollbar-thumb:hover": {
            //   backgroundColor: colors.darkBackgroundColor,
            // },
          },
          dividers: {
            borderTop: "none",
            borderBottom: "none",
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            backgroundColor: colors?.popupHeaderColor, // Changed to transparent
            color: colors.fontColor,
            fontWeight: "bold",
            borderBottom: "none", // Remove bottom border
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            backgroundColor: "transparent", // Add this to make actions transparent
            borderTop: "none", // Remove top border
            paddingTop: 0, // Remove gap between content and actions
          },
        },
      },
      MuiToggleButtonGroup: {
        styleOverrides: {
          root: {
            backgroundColor: colors.darkBackgroundColor,
            borderRadius: 8,
            padding: 4,
            width: "fit-content",
          },
        },
      },
      MuiToggleButton: {
        styleOverrides: {
          root: ({ theme, ownerState }) => ({
            fontWeight: "bold",
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            borderRadius: 8,
            "&.Mui-selected": {
              color: "#fff",
              backgroundColor:
                ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
              "&:hover": {
                backgroundColor:
                  ownerState.value === "BUY" ? "#00a543" : "#b71c1c",
              },
            },
            "&:not(.Mui-selected)": {
              color: ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
              // "&:hover": {
              //   backgroundColor: "#2c2c3a",
              // },
            },
          }),
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontWeight: `${allColors.fontStyle} !important`,
            fontStyle: `${allColors.fontStyle} !important`,
            fontFamily: `${allColors.font} !important`,
            "*": {
              fontWeight: `${allColors.fontStyle} !important`, // enforce all text bold
              fontStyle: `${allColors.fontStyle} !important`,
              fontFamily: `${allColors.font} !important`,
            },
            // "&::-webkit-scrollbar": {
            //   width: "8px",
            //   height: "8px",
            // },
            // "&::-webkit-scrollbar-track": {
            //   background: colors.darkBackgroundColor,
            // },
            // "&::-webkit-scrollbar-thumb": {
            //   backgroundColor: colors.darkBackgroundColor,
            //   borderRadius: "10px",
            //   border: "2px solid transparent",
            //   backgroundClip: "content-box",
            // },
            // "&::-webkit-scrollbar-thumb:hover": {
            //   backgroundColor: colors.darkBackgroundColor,
            // },
          },
        },
      },
    },
  });
};

// Static export for dark theme with default colors (for backwards compatibility)
export const darkTheme = createDarkTheme({});

export const createLightTheme = (allColors) => {
  const defaults = {
    navbarColor: "#fff",
    lightBackgroundColor: "#ffffff",
    backgroundColor1: "#f5f5f5",
    backgroundColor2: "rgb(222, 222, 222)",
    buttonColor: "#464342",
    fontColor: "#000000",
    popupHeaderColor: "#e4e0e0",
    popupBodyColor: "#ffffff",
    tableHeaderColor: "#e0e0e0",
    tableBodyColor: "#ffffff",
  };

  const colors = {
    navbarColor: allColors?.navbarColor || defaults.navbarColor,
    lightBackgroundColor:
      allColors?.lightBackgroundColor || defaults.lightBackgroundColor,
    backgroundColor1: allColors?.backgroundColor1 || defaults.backgroundColor1,
    backgroundColor2: allColors?.backgroundColor2 || defaults.backgroundColor2,
    buttonColor: allColors?.lightInternalButtonColor || defaults.buttonColor,
    fontColor: allColors?.lightFontColor || defaults.fontColor,
    popupHeaderColor:
      allColors?.lightPopupHeaderColor || defaults.popupHeaderColor,
    popupBodyColor: allColors?.lightPopupBodyColor || defaults.popupBodyColor,
    tableHeaderColor:
      allColors?.lightTableHeaderColor || defaults.tableHeaderColor,
    tableBodyColor: allColors?.lightTableBodyColor || defaults.tableBodyColor,
  };

  return createTheme({
    palette: {
      mode: "light",
      primary: {
        main: colors.buttonColor,
      },
      background: {
        default: colors.lightBackgroundColor,
        paper: "rgb(222, 222, 222)",
      },
      text: {
        primary: colors.fontColor,
        secondary: colors.fontColor,
      },
    },

    typography: {
      fontFamily: allColors.lightFont,
      fontSize: allColors?.lightFontSize || 14,
      fontStyle: allColors?.lightFontStyle,
      fontColor: colors?.fontColor,
      allVariants: {
        color: colors.fontColor,
        fontStyle: colors.lightFontStyle,
      },
      h1: {
        fontSize: `${allColors.lightFontSize * 2.4}px`,

        color: colors.fontColor,
      },
      h2: {
        fontSize: `${allColors.lightFontSize * 2}px`,

        color: colors.fontColor,
      },
      h3: {
        fontSize: `${allColors.lightFontSize * 1.8}px`,

        color: colors.fontColor,
      },
      h4: {
        fontSize: `${allColors.lightFontSize * 1.5}px`,

        color: colors.fontColor,
      },
      h5: {
        fontSize: `${allColors.lightFontSize * 1.3}px`,

        color: colors.fontColor,
      },
      h6: {
        fontSize: `${allColors.lightFontSize * 1.1}px`,

        color: colors.fontColor,
      },
      subtitle1: {
        fontSize: `${allColors.lightFontSize * 1}px`,
        color: colors.fontColor,
      },
      subtitle2: {
        fontSize: `${allColors.lightFontSize * 0.9}px`,
        color: colors.fontColor,
      },
      body1: {
        fontSize: `${allColors.lightFontSize}px`,
        color: colors.fontColor,
      },
      body2: {
        fontSize: `${allColors.lightFontSize * 0.9}px`,
        color: colors.fontColor,
      },
      button: {
        textTransform: "none",

        fontSize: `${allColors.lightFontSize}px`,
        color: colors.fontColor,
      },
      caption: {
        fontSize: `${allColors.lightFontSize * 0.8}px`,
        color: colors.fontColor,
      },
      overline: {
        fontSize: `${allColors.lightFontSize * 0.75}px`,
        color: colors.fontColor,
        textTransform: "uppercase",
      },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: colors.lightBackgroundColor,
            color: colors.fontColor,
            fontStyle: allColors?.lightFontStyle,
            fontWeight: allColors?.lightFontStyle,
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: colors.tableHeaderColor,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: colors.fontColor,
            fontWeight: "bold",
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            backgroundColor: `color-mix(in srgb, ${colors.lightBackgroundColor} 80%, black 20%)`,
            color: colors.lightFontColor,
          },
        },
      },
      MuiToggleButtonGroup: {
        styleOverrides: {
          root: {
            backgroundColor: colors.lightBackgroundColor,
            borderRadius: 8,
            padding: 4,
            width: "fit-content",
          },
        },
      },
      MuiToggleButton: {
        styleOverrides: {
          root: ({ theme }) => ({
            fontWeight: "bold",
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            borderRadius: 8,
            "&.Mui-selected": {
              color: "#fff",
              backgroundColor: (ownerState) =>
                ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
              "&:hover": {
                backgroundColor: (ownerState) =>
                  ownerState.value === "BUY" ? "#00a543" : "#b71c1c",
              },
            },
            "&:not(.Mui-selected)": {
              color: (ownerState) =>
                ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
              // "&:hover": {
              //   backgroundColor: "#e0e0e0",
              // },
            },
          }),
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            backgroundColor: colors.popupHeaderColor,
            color: colors.fontColor,
            fontWeight: "bold",
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontWeight: `${allColors.lightFontStyle} !important`,
            fontStyle: `${allColors.lightFontStyle} !important`,
            fontFamily: `${allColors.lightFont} !important`,
            "*": {
              fontWeight: `${allColors.lightFontStyle} !important`, // enforce all text bold
              fontStyle: `${allColors.lightFontStyle} !important`,
              fontFamily: `${allColors.lightFont} !important`,
            },
            // "&::-webkit-scrollbar": {
            //   width: "8px",
            //   height: "8px",
            // },
            // "&::-webkit-scrollbar-track": {
            //   background: "#1e1e1e",
            // },
            // "&::-webkit-scrollbar-thumb": {
            //   backgroundColor: "#888",
            //   borderRadius: "10px",
            //   border: "2px solid transparent",
            //   backgroundClip: "content-box",
            // },
            // "&::-webkit-scrollbar-thumb:hover": {
            //   backgroundColor: "#555",
            // },
          },
        },
      },
    },
  });
};

export const lightTheme = createLightTheme({});

// import { createTheme } from "@mui/material/styles";

// // === Dark Theme ===
// export const darkTheme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: {
//       main: "#90caf9",
//     },
//     background: {
//       default: "#121212",
//       paper: "#1e1e1e",
//     },
//     text: {
//       primary: "#ffffff",
//       secondary: "#b0bec5",
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#1e1e1e",
//           color: "#ffffff",
//         },
//       },
//     },
//     MuiTableHead: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#202023",
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         head: {
//           color: "#ffffff",
//           fontWeight: "bold",
//         },
//       },
//     },
//     MuiCardContent: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#24262d",
//           color: "#ffffff",
//         },
//       },
//     },
//     MuiDialogContent: {
//       styleOverrides: {
//         root: {
//           "&::-webkit-scrollbar": {
//             width: "8px",
//             height: "8px",
//           },
//           "&::-webkit-scrollbar-track": {
//             background: "#1e1e1e",
//           },
//           "&::-webkit-scrollbar-thumb": {
//             backgroundColor: "#888",
//             borderRadius: "10px",
//             border: "2px solid transparent",
//             backgroundClip: "content-box",
//           },
//           "&::-webkit-scrollbar-thumb:hover": {
//             backgroundColor: "#555",
//           },
//         },
//       },
//     },
//     MuiToggleButtonGroup: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#2c2c3a",
//           borderRadius: 8,
//           padding: 4,
//           width: "fit-content",
//         },
//       },
//     },
//     MuiToggleButton: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           fontWeight: "bold",
//           paddingLeft: theme.spacing(4),
//           paddingRight: theme.spacing(4),
//           borderRadius: 8,
//           "&.Mui-selected": {
//             color: "#fff",
//             backgroundColor: (ownerState) =>
//               ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
//             "&:hover": {
//               backgroundColor: (ownerState) =>
//                 ownerState.value === "BUY" ? "#00a543" : "#b71c1c",
//             },
//           },
//           "&:not(.Mui-selected)": {
//             color: (ownerState) =>
//               ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
//             "&:hover": {
//               backgroundColor: "#2c2c3a",
//             },
//           },
//         }),
//       },
//     },
//     MuiDialogTitle: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#383839",
//           color: "#fff",
//           fontWeight: "bold",
//         },
//       },
//     },

//     MuiCssBaseline: {
//       styleOverrides: {
//         body: {
//           "&::-webkit-scrollbar": {
//             width: "8px",
//             height: "8px",
//           },
//           "&::-webkit-scrollbar-track": {
//             background: "#1e1e1e",
//           },
//           "&::-webkit-scrollbar-thumb": {
//             backgroundColor: "#888",
//             borderRadius: "10px",
//             border: "2px solid transparent",
//             backgroundClip: "content-box",
//           },
//           "&::-webkit-scrollbar-thumb:hover": {
//             backgroundColor: "#555",
//           },
//         },
//       },
//     },
//   },
// });

// // === Light Theme ===
// export const lightTheme = createTheme({
//   palette: {
//     mode: "light",
//     primary: {
//       main: "#464342",
//     },
//     background: {
//       default: "#f5f5f5",
//       paper: "rgb(222, 222, 222)",
//     },
//     text: {
//       primary: "#000000",
//       secondary: "#455a64",
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#ffffff",
//           color: "#000000",
//         },
//       },
//     },
//     MuiTableHead: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#e0e0e0",
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         head: {
//           color: "#000000",
//           fontWeight: "bold",
//         },
//       },
//     },
//     MuiToggleButtonGroup: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#e0e0e0",
//           borderRadius: 8,
//           padding: 4,
//           width: "fit-content",
//         },
//       },
//     },
//     MuiCssBaseline: {
//       styleOverrides: {
//         body: {
//           "&::-webkit-scrollbar": {
//             width: "8px",
//             height: "8px",
//           },
//           "&::-webkit-scrollbar-track": {
//             background: "#1e1e1e",
//           },
//           "&::-webkit-scrollbar-thumb": {
//             backgroundColor: "#888",
//             borderRadius: "10px",
//             border: "2px solid transparent",
//             backgroundClip: "content-box",
//           },
//           "&::-webkit-scrollbar-thumb:hover": {
//             backgroundColor: "#555",
//           },
//         },
//       },
//     },
//     MuiToggleButton: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           fontWeight: "bold",
//           paddingLeft: theme.spacing(4),
//           paddingRight: theme.spacing(4),
//           borderRadius: 8,
//           "&.Mui-selected": {
//             color: "#fff",
//             backgroundColor: (ownerState) =>
//               ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
//             "&:hover": {
//               backgroundColor: (ownerState) =>
//                 ownerState.value === "BUY" ? "#00a543" : "#b71c1c",
//             },
//           },
//           "&:not(.Mui-selected)": {
//             color: (ownerState) =>
//               ownerState.value === "BUY" ? "#00c853" : "#d32f2f",
//             "&:hover": {
//               backgroundColor: "#e0e0e0",
//             },
//           },
//         }),
//       },
//     },
//     MuiDialogTitle: {
//       styleOverrides: {
//         root: {
//           backgroundColor: "#e4e0e0",
//           color: "#000",
//           fontWeight: "bold",
//         },
//       },
//     },
//   },
// });
